<template>
  <fb-form-body>
    <RecipeStep style="margin-top: 26px" v-model="stepActive" :stepList="stepList"/>

    <div style="margin-top: 24px">
      <keep-alive>
        <component @next="handleNext"
                   @lastStep="handleLastStep"
                   status="detail"
                   :load="load"
                   :is="currentView[stepActive]"></component>
      </keep-alive>
    </div>

  </fb-form-body>
</template>

<script>
import RecipeStep from "../../components/recipe-step/RecipeStep";
import RecipePhotoForm from "../../components/recipe-photo-form/RecipePhotoForm";
import FoodForm from '../../components/food-form/FoodForm';
import IntroductionForm from '../../components/introduction-form/IntroductionForm';
import RecipeCookingSteps from "../../components/recipe-cooking-steps/RecipeCookingSteps";
import ToolForm from '../../components/tool-form/ToolForm';
import UseTime from '../../components/use-time/UseTime';
import RecipeNutritionForm from "../../components/recipe-nutrition-form/RecipeNutritionForm";
import RecipeInfoForm from "../../components/recipe-info-form/RecipeInfoForm";
import RecipeFinishForm from "../../components/recipe-finish-form/RecipeFinishForm";

export default {
  name: "recipeEdit",
  components: {
    RecipeStep,
    RecipePhotoForm,
    FoodForm,
    IntroductionForm,
    RecipeCookingSteps,
    ToolForm,
    UseTime,
    RecipeNutritionForm,
    RecipeInfoForm,
    RecipeFinishForm
  },
  data() {
    return {
      stepActive: 0,
      currentView: {
        '0': 'RecipePhotoForm',
        '1': 'FoodForm',
        '2': 'IntroductionForm',
        '3': 'RecipeCookingSteps',
        '4': 'ToolForm',
        '5': 'UseTime',
        '6': 'RecipeNutritionForm',
        '7': 'RecipeInfoForm',
        '8': 'RecipeFinishForm',
      },
      stepList: [
        {title: '名字与图片', icon: 'camera'},
        {title: '准备食材', icon: 'food'},
        {title: '做饭介绍', icon: 'introduction'},
        {title: '烹饪步骤', icon: 'step'},
        {title: '所需工具', icon: 'tool'},
        {title: '花费时间', icon: 'time'},
        {title: '营养成分', icon: 'element'},
        {title: '更多信息', icon: 'info'},
        {title: '完成', icon: 'finish'},
      ],
      api: {
        detail: this.$api.recipe.detail,
        update: this.$api.recipe.update,
      },
      formData: {},
      load: false,
      code: ''
    }

  },
  methods: {
    handleNext(e) {
      this.formData = Object.assign(this.formData, e);
      this.stepActive++;
      this.handleScrollTop();
    },

    handleLastStep() {
      this.stepActive--;
      this.handleScrollTop();
    },

    handleScrollTop() {
      let el = document.getElementsByClassName("scroller")[1];
      el.scrollTop = 0;
    },

    handleGetDetail() {
      const vm = this;
      vm.$http.get(vm.api.detail, {params: vm.$route.query}).then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        let recipe = res.data.data['recipe'];
        recipe.type = recipe.type || "SOUP";
        this.$store.commit("CHANGE_RECIPE", {...recipe});
        vm.formData = recipe;
        vm.load = true;
      })

    },
  },
  created() {
    this.handleGetDetail();
  },
  beforeDestroy() {
    this.$store.commit("CLEAR_RECIPE");
  }
}
</script>

<style scoped>

</style>
